import pathfinder from '@fiverr-private/pathfinder';
import {
    PATHS,
    MODES,
    PATHFINDER,
    formatQueryParams,
    getCategorySlug,
    getSubCategorySlug,
    getNestedSubCategorySlug,
} from '../../utils';
import type { MapperItemConfig } from './types';

export const getStaticPagePath = (
    { categoryId, id, nestedSubCategoryId, filterId, mode, queryParams }: MapperItemConfig,
    locale?: string
) => {
    if (mode === MODES.PRO) {
        return PATHS.ROOT;
    }

    if (!(categoryId && id && filterId)) {
        return PATHS.ROOT;
    }

    if (
        isNaN(parseInt(categoryId, 10)) ||
        isNaN(parseInt(id, 10)) ||
        (nestedSubCategoryId && isNaN(parseInt(nestedSubCategoryId, 10)))
    ) {
        return PATHS.ROOT;
    }

    const categorySlug = getCategorySlug(categoryId, locale);
    const subCategorySlug = getSubCategorySlug(id, locale);

    let params: Record<string, string> = {
        category_id: categorySlug,
        id: subCategorySlug,
        filters_uid: filterId,
    };

    if (nestedSubCategoryId) {
        const nestedSubCategorySlug = getNestedSubCategorySlug(nestedSubCategoryId, id, locale);

        params = {
            ...params,
            nested_sub_category_id: nestedSubCategorySlug,
        };

        return pathfinder(PATHFINDER.NESTED_SUB_CATEGORY_STATIC_PAGE, params, formatQueryParams());
    }

    return pathfinder(PATHFINDER.SUB_CATEGORY_STATIC_PAGE, params, formatQueryParams({ queryParams }));
};
